import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

export const D2_FONT_SIZES = [
    "caption",
    "footnote",
    "callout",
    "body",
    "headline",
    "title",
    "figure",
    "display",
    "hero",
    "field",
] as const

export const D2_SHADOWS = [
    "card",
    "float",
    "active",
    "hairline",
    "hairline-strong",
    "focus",
    "panel",
    "island",
    "focus-field",
    "lift",
    "control",
    "selected",
    "halo",
    "divider-t",
    "divider-b",
    "rail",
    "hairline-danger",
    "glass",
] as const

export const D2_DURATIONS = [
    "fast",
    "base",
    "slow",
    "slower",
    "slowest",
] as const

export const D2_EASINGS = ["emphasized", "glide"] as const

export const D2_RADII = [
    "card",
    "field",
    "small",
    "paper",
    "panel",
    "row",
    "tile",
    "sheet",
    "sheetBottom",
] as const

const twMerge = extendTailwindMerge({
    extend: {
        theme: {
            text: [...D2_FONT_SIZES],
            shadow: [...D2_SHADOWS],
            ease: [...D2_EASINGS],
            radius: [...D2_RADII],
        },
        classGroups: {
            duration: [{ duration: [...D2_DURATIONS] }],
        },
    },
})

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}
